import { useQuery } from "@tanstack/react-query";

import { useApi } from "@/shared/api";

import { type TableApiCallParams } from "@/shared/types";
import { type PaginatedResponse } from "@/shared/types";
import { filterObjectKeys } from "@/shared/lib/utils";
import type { Teamlead } from "../model";

export const useTeamleads = (
  params: TableApiCallParams & { isMaster?: boolean; enabled?: boolean },
) => {
  const { api } = useApi();

  return useQuery<PaginatedResponse<Teamlead>>({
    queryKey: ["teamleads", filterObjectKeys(params, ["enabled"])],
    queryFn: async () => {
      const { data } = await api.get("/teamleads", {
        params: filterObjectKeys(params, ["enabled"]),
      });

      return data;
    },
    enabled: params.enabled,
  });
};
